module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/lux",
      "id": "nav-prev"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e45e105"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selection.vue
// module id = 29
// module chunks = 0